import { Controller } from "@hotwired/stimulus";

// On connect, scrolls to the first exercise that has not been answered yet.
// "Answered" is indicated by data-answered="true" on the label element inside
// the exercise wrapper. If all exercises are answered, does nothing.
export default class extends Controller {
  static targets = ["exercise"];

  connect() {
    const first = this.exerciseTargets.find(
      (el) => el.dataset.answered !== "true",
    );
    if (first) {
      first.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
